export enum SelectedAction {
  EDIT_AGENT_PRICINGS_RANGES = 'EDIT_AGENT_PRICINGS_RANGES',
  UPLOAD_PRICING_TO_CDN = 'UPLOAD_PRICING_TO_CDN',
  SEE_PRICING_IN_CDN = 'SEE_PRICING_IN_CDN',
}
